/* eslint-disable max-len */
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  createPeriodColumn,
  createTargetColumn,
  createTitleColumn,
} from 'pages/BackOfficePage/BackOfficeCategories/Promotion/CreatePromotion/PublishStep/PublishStep.tableColumns';
import { FlashPromotionPublicationTableData } from 'pages/BackOfficePage/BackOfficeCategories/Promotion/CreatePromotion/PublishStep/PublishStep.types';
import { STable } from 'pages/EstimatePage/EstimatePage.styled';
import { GetTitle } from 'pages/EstimatePage/TableSection/tableComponents';
import { Flex, Text, WithTooltip } from 'UI';

export const TableQuantityLimited = ({ data }: { data: FlashPromotionPublicationTableData }) => {
  const { t } = useTranslation();
  const getDataColumns = () => {
    return [
      createTitleColumn(t),
      {
        title: GetTitle(t('backoffice.promotion.price_option', 'Price option')),
        dataIndex: 'discountType',
        render: function renderDiscountType(discountType: string) {
          const discountTypeText = t(
            'backoffice.promotion.publication_preview.discount_type',
            'Based on {{discountType}}',
            { discountType },
          );
          return (
            <Flex minWidth={120} justify={'center'} align={'center'} data-cy={'price-option-value'}>
              <WithTooltip title={discountTypeText}>
                <Text type={'text'}>{discountTypeText}</Text>
              </WithTooltip>
            </Flex>
          );
        },
      },
      createPeriodColumn(t, {
        title: data.period.publicationEnd
          ? GetTitle(t('backoffice.promotion.publication_preview.period', 'Period'))
          : GetTitle(t('backoffice.promotion.publication_preview.starting_date', 'Starting date')),
        width: 90,
      }),
      {
        title: GetTitle(t('backoffice.promotion.publication_preview.references', 'References')),
        dataIndex: 'referenceQuantityLimited',
        render: function renderReferences(references: string) {
          return (
            <Flex justify={'center'} align={'center'} data-cy={'references-value'}>
              <WithTooltip title={references}>
                <Text type={'text'}>{references}</Text>
              </WithTooltip>
            </Flex>
          );
        },
      },
      {
        title: GetTitle(t('backoffice.promotion.publication_preview.discount', 'Discount')),
        dataIndex: 'discount',
        render: function renderDiscount(discount: string) {
          const discountText = `${discount}%`;
          return (
            <Flex justify={'center'} align={'center'} data-cy={'discount-value'}>
              <WithTooltip title={discountText}>
                <Text type={'text'}>{discountText}</Text>
              </WithTooltip>
            </Flex>
          );
        },
      },
      {
        title: GetTitle(t('backoffice.promotion.publication_preview.units', 'Units')),
        dataIndex: 'units',
        render: function renderTarget(units: string) {
          return (
            <Flex justify={'center'} align={'center'} data-cy={'units-value'}>
              <WithTooltip title={units}>
                <Text type={'text'}>{units}</Text>
              </WithTooltip>
            </Flex>
          );
        },
      },
      createTargetColumn(t, { separator: '\n' }),
    ];
  };

  if (!data) {
    return null;
  }
  return (
    <STable
      key={'promotions_flash_quantity_limited_table'}
      dataSource={[data]}
      columns={getDataColumns()}
      pagination={false}
    />
  );
};
